__turbopack_context__.v({
  "answerContainer": "FaqAnswer-module-scss-module__Er9ZYq__answerContainer",
  "answerDetails": "FaqAnswer-module-scss-module__Er9ZYq__answerDetails",
  "answerHeading": "FaqAnswer-module-scss-module__Er9ZYq__answerHeading",
  "answersContent": "FaqAnswer-module-scss-module__Er9ZYq__answersContent",
  "arrowIcon": "FaqAnswer-module-scss-module__Er9ZYq__arrowIcon",
  "blueBackground": "FaqAnswer-module-scss-module__Er9ZYq__blueBackground",
  "headingText": "FaqAnswer-module-scss-module__Er9ZYq__headingText",
  "mortgageFAQ": "FaqAnswer-module-scss-module__Er9ZYq__mortgageFAQ",
  "plusIconWrapper": "FaqAnswer-module-scss-module__Er9ZYq__plusIconWrapper",
});
